import React from 'react';
import {classes, style} from './doppe-action-type-rating-view.st.css';
import {flexRowAlignToStart} from '@wix/devzai-utils-react';
import {arrayGenerate} from '@wix/devzai-utils-common';
import {DoppeHideableValue, doppeHideableValueIsHidden} from '../../client-server-common';


export const DoppeActionTypeRatingView = React.memo(function DoppeActionTypePriceDataView(props: DoppeActionTypePriceDataView.Props) {
    const {
        rating,
        renderRatingContent = '★',
        style: styleProp,
        className,
        ...htmlAttributes
    } = props;

    if (doppeHideableValueIsHidden(rating)) {
        return null;
    }

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {}, className, flexRowAlignToStart())}
        >
            {
                arrayGenerate(rating, (index) => (
                    <div
                        key={index}
                        className={style(classes.star, {})}
                    >
                        {renderRatingContent}
                    </div>
                ))
            }
        </div>
    );
});

export namespace DoppeActionTypePriceDataView {

    export interface Props extends React.HTMLAttributes<any> {
        rating: DoppeHideableValue<1 | 2 | 3 | 4 | 5>;
        renderRatingContent?: React.ReactElement;
    }
}
